{
  "name": "@zimic/interceptor",
  "description": "Next-gen TypeScript-first HTTP intercepting and mocking",
  "keywords": [
    "zimic",
    "typescript",
    "types",
    "typegen",
    "validation",
    "inference",
    "http",
    "interceptor",
    "mock",
    "api",
    "static"
  ],
  "version": "1.4.1",
  "homepage": "https://zimic.dev/docs/interceptor",
  "repository": {
    "type": "git",
    "url": "https://github.com/zimicjs/zimic.git",
    "directory": "packages/zimic-interceptor"
  },
  "author": {
    "name": "Diego Aquino",
    "url": "https://github.com/diego-aquino"
  },
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/zimicjs"
  },
  "private": false,
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "engines": {
    "node": ">=22.0.0"
  },
  "license": "MIT",
  "files": [
    "package.json",
    "README.md",
    "LICENSE.md",
    "src",
    "!src/**/tests",
    "!src/**/__tests__",
    "!src/**/*.test.ts",
    "dist",
    "index.d.ts",
    "http.d.ts",
    "server.d.ts"
  ],
  "sideEffects": false,
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "index.d.ts",
  "bin": {
    "zimic-interceptor": "./dist/cli.js"
  },
  "exports": {
    ".": {
      "types": "./index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "default": "./dist/index.js"
    },
    "./http": {
      "types": "./http.d.ts",
      "import": "./dist/http.mjs",
      "require": "./dist/http.js",
      "default": "./dist/http.js"
    },
    "./server": {
      "types": "./server.d.ts",
      "import": "./dist/server.mjs",
      "require": "./dist/server.js",
      "default": "./dist/server.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "setup": "concurrently --names playwright,msw 'playwright install chromium' 'msw init ./public --no-save'",
    "dev": "tsup --watch",
    "cli": "node --enable-source-maps ./dist/cli.js",
    "build": "tsup",
    "lint": "eslint --cache --no-error-on-unmatched-pattern --no-warn-ignored --fix",
    "lint:turbo": "pnpm lint . --max-warnings 0",
    "style": "prettier --log-level warn --ignore-unknown --no-error-on-unmatched-pattern --cache",
    "style:check": "pnpm style --check",
    "style:format": "pnpm style --write",
    "test": "dotenv -v NODE_ENV=test -v FORCE_COLOR=1 -- vitest",
    "test:turbo": "dotenv -v CI=true -- pnpm run test --coverage --reporter verbose",
    "types:check": "tsc --noEmit",
    "postinstall": "node --enable-source-maps -e \"try{require('./dist/scripts/postinstall')}catch(error){console.error(error)}\""
  },
  "dependencies": {
    "@whatwg-node/server": "0.10.18",
    "isomorphic-ws": "5.0.0",
    "msw": "2.14.5",
    "picocolors": "^1.1.1",
    "ws": "8.20.0",
    "yargs": "18.0.0",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@types/node": "^25.6.2",
    "@types/ws": "^8.18.1",
    "@types/yargs": "^17.0.35",
    "@vitest/browser": "^4.1.5",
    "@vitest/browser-playwright": "^4.1.5",
    "@vitest/coverage-istanbul": "^4.1.5",
    "@zimic/eslint-config-node": "workspace:*",
    "@zimic/lint-staged-config": "workspace:*",
    "@zimic/tsconfig": "workspace:*",
    "@zimic/utils": "workspace:*",
    "concurrently": "^9.2.1",
    "dotenv-cli": "^11.0.0",
    "eslint": "^9.39.4",
    "playwright": "^1.59.1",
    "tsup": "^8.5.1",
    "typescript": "6.0.3",
    "vitest": "^4.1.5"
  },
  "peerDependencies": {
    "@zimic/http": "^1.2.0 || workspace:*",
    "typescript": "^5.0.0 || ^6.0.0"
  },
  "peerDependenciesMeta": {
    "typescript": {
      "optional": true
    }
  }
}
